<template>
  <VExpansionPanels v-bind="$props">
    <slot />
  </VExpansionPanels>
</template>

<script>
import { VExpansionPanels } from 'vuetify/lib';

export default {
  name: 'WorkExpansionPanels',
  components: {
    VExpansionPanels,
  },
  props: { ...VExpansionPanels.options.props },
};
</script>
